import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'accent';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 active:scale-95 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-purple-600 text-white hover:bg-purple-700 shadow-md shadow-purple-600/20',
    secondary: 'bg-purple-100 text-purple-900 hover:bg-purple-200',
    outline: 'border-2 border-purple-200 text-purple-700 hover:bg-purple-50',
    ghost: 'text-purple-700 hover:bg-purple-50',
    accent: 'bg-[#FFFC00] text-purple-900 hover:bg-[#E6E300] shadow-md shadow-yellow-400/20'
  };
  const sizes = {
    sm: 'text-xs px-3 py-1.5',
    md: 'text-sm px-5 py-2.5',
    lg: 'text-base px-6 py-3.5'
  };
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} {...props} data-id="element-1596">
      {children}
    </button>;
}